import type { QueryInput } from "@/models/compound";
import { LoadingStrategy } from "@/algorithms/loadingStrategies/LoadingStrategy";

export class OldestFirst extends LoadingStrategy {
  getQueryInputs(
    identifier: string,
    maxObjectReturn: number,
    onlyNewElements: boolean
  ): QueryInput[] {
    const warehouseData = this.getWarehouseData(identifier);
    if (undefined === warehouseData) return [] as QueryInput[];

    const { newFilenames, startedFilenames } = this.getNewAndStartedFilenames(
      warehouseData.progress
    );

    // Filenames are stored oldestFirst by default, so the order is the same
    // as the one that returns the function.
    const joinedFilenames = onlyNewElements
      ? [...newFilenames]
      : [...startedFilenames, ...newFilenames];

    return this.createQueryInputObjects(
      identifier,
      warehouseData,
      maxObjectReturn,
      joinedFilenames
    );
  }
}
